module.exports = __webpack_public_path__ + "static/media/exo-latin-300.572c7fda.woff2";